import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';

import { SharedModule } from '../shared/shared.module';

import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { PasswordRequestComponent } from './password/request/request.component';
import { PasswordResetComponent } from './password/reset/reset.component';
import { EmailResendComponent } from './email/resend/resend.component';
import { EmailVerifyComponent } from './email/verify/verify.component';
import { CaptchaComponent } from './captcha/captcha.component';
import { LoginAccessGuard } from './_guards/login-access.guard';
import {UserBlockingComponent} from './user-blocking/user-blocking.component';

const authRoutes: Routes = [
  {
    path: '', component: AuthComponent, children: [
      {path: '', redirectTo: 'login', pathMatch: 'full'},
      {path: 'login', component: LoginComponent, data: {title: 'Sign In'}, canActivate: [LoginAccessGuard]},
      {path: 'login/:disCap', component: LoginComponent, data: {title: 'Sign In'}, canActivate: [LoginAccessGuard]},
      {path: 'password/request', component: PasswordRequestComponent, data: {title: 'Forgot Password'}},
      {path: 'password/reset/:token', component: PasswordResetComponent, data: {title: 'Password Reset'}},
      {path: 'email/resend', component: EmailResendComponent, data: {title: 'Activation Email'}},
      {path: 'email/verify/:token', component: EmailVerifyComponent, data: {title: 'Set Your Password'}},
      {path: 'password/reset', component: PasswordResetComponent, data: {scope: 'expired'}},
      {path: 'blocked', component: UserBlockingComponent, data: {title: 'Sign In'}},
    ]
  }
];

@NgModule({
  declarations: [
    AuthComponent,
    LoginComponent,
    PasswordRequestComponent,
    PasswordResetComponent,
    EmailResendComponent,
    EmailVerifyComponent,
    LoginComponent,
    CaptchaComponent,
    UserBlockingComponent
  ],
  imports: [
    SharedModule,
    RouterModule.forChild(authRoutes),
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  providers: []
})

export class AuthModule {
}
